import React, { Fragment, Component } from 'react';
import { LanguageSwitcher, Button, AuthenticationContext, ButtonCta, GelContentContainer, HeroBanner, Loading } from "cw-styleguide-react";
import { route, routeTranslated } from "../routes";
import Banner from "../images/banner.png";
import { withTranslation, Trans } from 'react-i18next';

class LandingView extends Component {
  render() {
    if (!this.props.content) {
      return <Loading />;
    }

    return (
      <AuthenticationContext.Consumer>
        {({ isAuthenticated, login }) => (
          <Fragment>
            <LanguageSwitcher to={routeTranslated('landing')} />
            <HeroBanner
              link={route('step1')}
              imageSrc={Banner}
              imageAlt={this.props.content.banner.alt}
              title={
                <Fragment>
                  {this.props.content.banner.title}<br />{this.props.content.banner.subtitle}
                </Fragment>
              }
              buttonText={this.props.content.button.text}
            />
            <GelContentContainer>
              <Trans i18nKey={'local:landing.introduction'}>
                <h2 className="style style--introduction" />
                <ul className="style--list-square style--list-no-bg">
                  <li />
                </ul>
              </Trans>
              {!isAuthenticated &&
                <Trans i18nKey={'local:landing.prompt'}>
                  <p>
                    <Button asLink={true} onClick={login} role="button" />
                  </p>
                </Trans>
              }
              <ButtonCta
                url={route('step1')}
                title={this.props.content.button.altText}
              >
                {this.props.content.button.text}
              </ButtonCta>
              <p>{this.props.content.credits}</p>
            </GelContentContainer>
          </Fragment>
        )}
      </AuthenticationContext.Consumer>
    )
  }
}

export default withTranslation('local')(LandingView);
